import { FormControl, Grid, Typography, Box, Select, InputLabel
    , TextField, FormHelperText, IconButton, Tooltip } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import DirectionSearch from './DirectionSearch';
import api from "../services/api";
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setListTipos, setListEstados } from "../redux/filialSlice";

const Filial = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.filial.entity);
    const defaultEntity = useSelector((state) => state.filial.defaultEntity);
    const listTipos = useSelector((state) => state.filial.listTipos);
    const listEstados = useSelector((state) => state.filial.listEstados);
    const dispatch = useDispatch();
    // La direccion se elige en la ventana de busqueda, como en las direcciones de
    // las personas: aqui solo se muestran el ubigeo y el detalle ya elegidos.
    const [openDirectionSearch, setOpenDirectionSearch] = React.useState(false);
    const openCloseDirectionSearch = () => { setOpenDirectionSearch(!openDirectionSearch); };

    // Al elegir una direccion se llenan el ubigeo, la direccion y el id que se
    // guarda. Los dos primeros solo se muestran.
    const setSelectDirectionSearch = (direccion) => {
        dispatch(setData({ name: "idDireccion", value: direccion.id }));
        dispatch(setData({ name: "idUbigeo", value: direccion.idUbigeo }));
        dispatch(setData({ name: "codigoUbigeo", value: direccion.codigoUbigeo || direccion.ubigeo || "" }));
        // El ubigeo se muestra completo: departamento, provincia y distrito.
        const resumenUbigeo = [direccion.departamento, direccion.provincia, direccion.ubigeo]
            .filter(Boolean).join(" / ");
        dispatch(setData({ name: "ubigeo", value: resumenUbigeo || direccion.ubigeo || "" }));
        dispatch(setData({ name: "direccion", value: direccion.detalle || "" }));
    }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Filial/GetFilialById?idFilial=" + params.id)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: {} };
            });

        if (response.data?.data == null) {
            dispatch(setEntity(defaultEntity));
        }
        else {
            dispatch(setEntity(response.data.data));
        }
    }, [])

    // Tipo de local (catalogo 83): Principal, Secundario.
    const fetchListTipos = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=83")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListTipos(response?.data?.data || []));
    }, [])

    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListEstados(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListTipos();
        fetchListEstados();
    }, []);

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity.codigo || ""}
                        onChange={(event) => dispatch(setData({ name: "codigo", value: event.target.value }))}
                        disabled={isReadOnly}
                        size="small"
                        // Sin shrink la etiqueta queda dentro del campo y se
                        // superpone con el texto ya escrito.
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="nombre"
                        label="Nombre"
                        fullWidth
                        value={entity.nombre || ""}
                        onChange={(event) => dispatch(setData({ name: "nombre", value: event.target.value }))}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                {/* Ubigeo y direccion no se escriben: se eligen en la ventana de
                    busqueda con la lupa. */}
                <Grid item xs={6} sm={3}>
                    <Grid container spacing={0.5} alignItems="center">
                        <Grid item xs={11}>
                            <TextField
                                required
                                name="ubigeo"
                                label="Ubigeo"
                                fullWidth
                                value={entity.ubigeo || ""}
                                disabled
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Tooltip title="Buscar Direccion">
                                <IconButton
                                    aria-label="Buscar Direccion"
                                    size="small"
                                    disabled={isReadOnly}
                                    onClick={openCloseDirectionSearch}
                                >
                                    <IconSearch fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="direccion"
                        label="Direccion"
                        fullWidth
                        value={entity.direccion || ""}
                        disabled
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        helperText={!(entity.idDireccion > 0) ? "Elija la direccion con la lupa" : ""}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-tipo">Tipo</InputLabel>
                        <Select
                            native
                            label="Tipo"
                            value={entity.idTipo || 0}
                            onChange={(event) => dispatch(setData({ name: "idTipo", value: event.target.value }))}
                            inputProps={{
                                name: 'idTipo',
                                id: 'input-tipo',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipos.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado || 0}
                            onChange={(event) => dispatch(setData({ name: "idEstado", value: event.target.value }))}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <DirectionSearch
                open={openDirectionSearch}
                openClose={openCloseDirectionSearch}
                setSelection={setSelectDirectionSearch}
            />
        </Grid>
    );
}
export default Filial;